import CategoryMegaMenuComponent from '../components/CategoryNav/CategoryMegaMenu';
import { connect } from 'react-redux';

const CategoryMegaMenu = connect((state) => state)(CategoryMegaMenuComponent as any);

export default CategoryMegaMenu;
